import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import ProductPurchases from "./ProductPurchases";
import { fetchProductPurchases } from "../../processes/purchaseProcesses";
import {
  getProductPurchases,
  getProductPurchasesLoading,
  getProductPurchasesPagination
} from "../../selectors/purchaseSelectors";
import { getCurrentUserId } from "../../selectors/userSelectors";

function ProductPurchasesContainer(props) {
  const { dispatch, productId, currentUserId } = props;
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (productId && currentUserId) {
      fetchProductPurchases(dispatch, { productId, userId: currentUserId, page: page });
    }
  }, [dispatch, productId, page, currentUserId]);

  const handlePageChange = useCallback((e, { activePage }) => {
    setPage(activePage);
  }, []);

  return (
    <ProductPurchases
      {...props}
      page={page}
      onPageChange={handlePageChange}
    />
  );
}

function mapStateToProps(state, ownProps) {
  const { productId } = ownProps;
  const pagination = getProductPurchasesPagination(state, productId);
  return {
    productId,
    purchases: getProductPurchases(state, productId),
    loading: getProductPurchasesLoading(state),
    pagination,
    totalPages: pagination?.totalPages || 0,
    currentUserId: getCurrentUserId(state),
  };
}

export default connect(mapStateToProps)(ProductPurchasesContainer);
